var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row p-3 mt-2 bg-white shadow-sm bg-white",
      attrs: { "data-cy": "file" }
    },
    [
      _c(
        "div",
        { staticClass: "col-1 text-center text-primary" },
        [
          _c("b-form-checkbox", {
            attrs: { "data-cy": "checkbox-file" },
            on: { change: _vm.selectFile },
            model: {
              value: _vm.file.selected,
              callback: function($$v) {
                _vm.$set(_vm.file, "selected", $$v)
              },
              expression: "file.selected"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-1", attrs: { "data-cy": "flow-number" } }, [
        _vm.file.app === "FEB"
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Flujo de Febos",
                    expression: "'Flujo de Febos'"
                  }
                ]
              },
              [
                _c(
                  "vs-chip",
                  {
                    staticClass: "cursor-pointer mr-2",
                    class: { "text-success": _vm.wasCopied },
                    attrs: { color: "warning", "data-cy": "file-number" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.copyToClipboard(
                          _vm.file.idAprobacion,
                          _vm.file.numero
                        )
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.file.numero) + " ")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.file.app === "ED" && _vm.file.tipoDocumento === "ARCHIVO-RP"
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Repositorio",
                    expression: "'Repositorio'"
                  }
                ]
              },
              [
                _c(
                  "vs-chip",
                  {
                    staticClass: "cursor-pointer mr-2",
                    class: { "text-success": _vm.wasCopied },
                    attrs: { color: "primary", "data-cy": "file-number" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.copyToClipboard(
                          _vm.file.idAprobacion,
                          _vm.file.numero
                        )
                      }
                    }
                  },
                  [
                    _c("vs-avatar", { attrs: { color: "primary", text: "R" } }),
                    _vm._v(" " + _vm._s(_vm.file.numero) + " ")
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.file.app === "ED" && _vm.file.tipoDocumento === "EXP"
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Expediente",
                    expression: "'Expediente'"
                  }
                ]
              },
              [
                _c(
                  "vs-chip",
                  {
                    staticClass: "cursor-pointer mr-2",
                    class: { "text-success": _vm.wasCopied },
                    attrs: { color: "primary", "data-cy": "file-number" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.copyToClipboard(
                          _vm.file.idAprobacion,
                          _vm.file.numero
                        )
                      }
                    }
                  },
                  [
                    _c("vs-avatar", { attrs: { color: "primary", text: "E" } }),
                    _vm._v(" " + _vm._s(_vm.file.numero) + " ")
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.file.app === "ED" && _vm.file.tipoDocumento === "ARCHIVO"
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Archivo",
                    expression: "'Archivo'"
                  }
                ]
              },
              [
                _c(
                  "vs-chip",
                  {
                    staticClass: "cursor-pointer mr-2",
                    class: { "text-success": _vm.wasCopied },
                    attrs: { color: "primary", "data-cy": "file-number" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.copyToClipboard(
                          _vm.file.idAprobacion,
                          _vm.file.numero
                        )
                      }
                    }
                  },
                  [
                    _c("vs-avatar", { attrs: { color: "primary", text: "A" } }),
                    _vm._v(" " + _vm._s(_vm.file.numero) + " ")
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "col-2", attrs: { "data-cy": "flow-name" } }, [
        _vm.file.nombre.length > 30
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.file.nombre,
                    expression: "file.nombre"
                  }
                ]
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.file.nombre.substring(0, 30) + "...") + " "
                )
              ]
            )
          : _c("div", [_vm._v(_vm._s(_vm.file.nombre))])
      ]),
      _c(
        "div",
        { staticClass: "col-2" },
        [
          _vm.file.aprovacionesEjecucionEstadoId.toString() ===
          _vm.FileStates.DISMISSED
            ? _c(
                "vs-chip",
                { attrs: { title: "Desestimado", "data-cy": "dismissed" } },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "mail_outline", color: "#4e94e0" }
                  }),
                  _vm._v(" Desestimado ")
                ],
                1
              )
            : _vm._e(),
          _vm.file.aprovacionesEjecucionEstadoId.toString() ===
          _vm.FileStates.PREPARED
            ? _c(
                "vs-chip",
                { attrs: { title: "Preparado", "data-cy": "prepared" } },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "query_builder", color: "#4e94e0" }
                  }),
                  _vm._v(" Preparado ")
                ],
                1
              )
            : _vm._e(),
          _vm.file.aprovacionesEjecucionEstadoId.toString() ===
          _vm.FileStates.INITIATED
            ? _c(
                "vs-chip",
                { attrs: { title: "Iniciado", "data-cy": "initiated" } },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "access_time", color: "#43C3B9" }
                  }),
                  _vm._v(" Iniciado ")
                ],
                1
              )
            : _vm._e(),
          _vm.file.aprovacionesEjecucionEstadoId.toString() ===
          _vm.FileStates.APPROVED
            ? _c(
                "vs-chip",
                { attrs: { title: "Aprobado", "data-cy": "aprobed" } },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "thumb_up", color: "#28c76f" }
                  }),
                  _vm._v(" Aprobado ")
                ],
                1
              )
            : _vm._e(),
          _vm.file.aprovacionesEjecucionEstadoId.toString() ===
          _vm.FileStates.REJECTED
            ? _c(
                "vs-chip",
                { attrs: { title: "Rechazado", "data-cy": "rejected" } },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "thumb_down", color: "#ea5455" }
                  }),
                  _vm._v(" Rechazado ")
                ],
                1
              )
            : _vm._e(),
          _vm.file.aprovacionesEjecucionEstadoId.toString() ===
          _vm.FileStates.CANCELED
            ? _c(
                "vs-chip",
                { attrs: { title: "Anulado", "data-cy": "canceled" } },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "move_to_inbox", color: "#ea5455" }
                  }),
                  _vm._v(" Anulado ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-2" },
        [
          _vm.file.pasoEjecucion.aprobacionesPasoEstadoId
            ? _c("steps-info", {
                attrs: { step: _vm.file.pasoEjecucion.aprobacionesPasoEstadoId }
              })
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "col-2" }, [
        _vm._v(" " + _vm._s(_vm.file.fechaInicioProceso) + " ")
      ]),
      _c(
        "div",
        { staticClass: "col-2" },
        [
          _c(
            "vs-chip",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Nombre de documento en flujo",
                  expression: "'Nombre de documento en flujo'"
                }
              ],
              attrs: { color: "warning", transparent: "" }
            },
            [
              _c("vs-avatar", { attrs: { icon: "description" } }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm._f("truncate")(_vm.file.documentos[0].objetoNombre, 20)
                  ) +
                  " "
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }